export const formatEquipmentType = (type, snake = false) => {
  let replace = snake ? '_$1' : ' $1';
  type = type.replace(/([A-Z])/g, replace).trim();

  return snake
    ? type.toLowerCase()
    : type.charAt(0).toUpperCase() + type.slice(1);
};

export const disableButtonByStatus = (status) => {
  return status !== 'In Progress' && status !== 'Incomplete';
}